import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function scrollSlider() {
    var section = document.querySelector("#scroll-slider-js");
    if (section == undefined || section == null) {
        return;
    }
    var w = jQuery(window).width();
    if (w <= 740) {
        scrollSliderMobile();
    } else {
        scrollSliderDesktop();
    }
}

export function scrollSliderMobile() {
  //let scrollslider = ScrollTrigger.getById("scrollslider");
    var $targetElement = jQuery(".sticky-slider");
    var section = document.querySelector("#scroll-slider-js");
    jQuery(section).find(".sticky-slider").removeAttr("style");

    killScroll('scrollslider');
    
    if (
        jQuery($targetElement).length != 0 &&
        jQuery(".sticky-slider.slick-initialized").length == 0
    ) {
        jQuery($targetElement).slick({
            infinite: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            touchThreshold: 10,
            draggable: true,
            swipeToSlide: true,
            autoplay: true,
            arrows: false,
        });
        // on click 'move-car-left' move carousel to the left
        jQuery('.move-sti-left').click(function() {
            $targetElement.slick('slickPrev');
        });
        // on click 'move-car-right' move carousel to the right
        jQuery('.move-sti-right').click(function() {
            $targetElement.slick('slickNext');
        });
    }
}

export function scrollSliderDesktop() {
    if (jQuery(".sticky-slider.slick-initialized").length != 0) {
        jQuery(".sticky-slider").slick("unslick");
    }
    var section = document.querySelector("#scroll-slider-js");
    killScroll('scrollslider');  

    var child = jQuery(section).find(".slide-wrap");
    var movingElement = jQuery(section).find(".sticky-slider");
    var totalWidth = child.length * child.outerWidth();
    var totalHeight = (child.length - 1) * child.outerHeight() + "px";
    var viewportWidth = window.innerWidth;
    var endPoint = ((viewportWidth - 20) / totalWidth) * 100 - 100; //20 is scrollbar length
    var startPoint = viewportWidth * 0.004;

    if (
        ScrollTrigger.getById("sticky-section") == undefined ||
        ScrollTrigger.getById("sticky-section") == null
    ) {
        let tl = gsap.timeline({
            scrollTrigger: {
                id: "scrollslider",
                trigger: section,
                pin: true,
                start: "top top",
                end: totalHeight,
                scrub: 1,
                //markers: true,
            },
        });
        //setting the width of the moving element
        movingElement.css("width", totalWidth + "px");

        tl.fromTo(
            movingElement,
            {
                x: startPoint + "%",
            },
            {
                x: endPoint + "%",
            },
            "start"
        );
    }
}

export function killScroll(id) {
  //console.log(ScrollTrigger.getById(id));
  let ele = ScrollTrigger.getById(id);
    if (ele != undefined || ele != null) {
      ScrollTrigger.getAll().forEach(st => st.vars.id === id && st.kill());
           console.log('killed');
    }
}